/**
 * Checks if an error is the result of a request cancellation (AbortController)
 */

function isAbortError(error) {
  if (!error) {
    return false;
  }

  // Standard AbortError thrown by AbortController.abort()
  if (error?.name === 'AbortError') {
    return true;
  }

  // YolaHttpClient wraps axios AbortError as ResponseError: canceled
  if (error?.name === 'ResponseError: canceled') {
    return true;
  }

  // Axios cancel code when request is canceled via AbortSignal
  if (error?.code === 'ERR_CANCELED') {
    return true;
  }

  return false;
}

export default isAbortError;
